// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bewertung-allgemeine-screen{
  position: relative;
  /*TEXT FONT*/
  font-family: Inter;
  font-style: normal;
}

/* SIDE SELECTOR START*/

.selector-container{
  position: relative;
  display: flex;
  flex-direction: row;
  top: 35px;
  height: fit-content;
  margin-right: 42px;
  margin-left: 42px;
  border-radius: 10px;
  background: var(--searchbar-background);

  /*Text Font*/
  text-align: center;
  /* Inter / 24 sp • H5 */
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
}

.selector-item-selected {
  display: flex;
  align-items: center; /* Center vertically */
  justify-content: center; /* Center horizontally */
  border-radius: 10px;
  cursor: pointer;
  margin: 5px;
  background: var(--white-base);
  width: 100%;
  text-align: center; /* Center text within the flex container */
}

.selector-item-not-selected {
  display: flex;
  align-items: center; /* Center vertically */
  justify-content: center; /* Center horizontally */
  border-radius: 10px;
  cursor: pointer;
  margin: 5px;
  width: 100%;
  text-align: center; /* Center text within the flex container */
}

.selector-divider {
  width: 1.48px;
  height: 50.8px;
  background-color: var(--gray-20);
  margin: 10px;
}
/* SIDE SELECTOR END */

/* MAIN CONTENT START*/
.singleContent-container1 {
  position: relative;
  margin-top: 80px;
  margin-left: var(--content-space);
  margin-right: var(--content-space);
  margin-bottom: 118px;
  /* Add vertical gap between children */
  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 30px;
  border-radius: 10px;
  border: 1px solid var(--border);
  background: var(--white-base);

  /* TEXT FONT */
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 18px */
}

.singleContent-container1-selector{
  position: relative;
  margin-right: 0;
  margin-left: auto;
  padding: 5px 10px;
  width: fit-content;
  background-color: var(--gray-20);
  border-radius: 8px;
  border: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;

  /* TEXT FONT */
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 18px */
}

.ba-singleContent-container-selector-item {
  background-color: var(--white-base); /* Background color for options */
  color: var(--gray-40);
}

.HeaderCell-Custom {
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
}

.table-content-editing-input {
  width: 90%;
  height: 15px;
  margin: 3px;
  border: 1px solid var(--gray-20);
  outline: none;
  border-radius: 5px;

  padding:2%;
  font-family: Poppins;
}
.table-content-editing-input-red{
  border: 1px solid var(--accents-alizarin-red);
}
.table-content-edit-span {
  padding:3%;
}
.table-content-save-button,
.table-content-stop-button,
.table-content-edit-button{
  height: 30px;
  border-radius: 5px;

  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  color: white;
  font-family: Poppins;
  font-weight: 600;
}

.table-content-edit-button{
  border: none;
  background-color: var(--blue-50);
}
.table-content-save-stop-button{
  display: flex;
  flex-direction: row;
  gap: 10%;
}
  .table-content-save-button{
    background-color: var(--green-50);
    width: 45%;
  }
  .table-content-stop-button{
    background-color: var(--accents-alizarin-red);
    width: 45%;
  }
.table-content-save-button:hover,
.table-content-stop-button:hover,
.table-content-edit-button:hover {
  transform: scale(1.07); 
  transition: transform 0.3s ease;
}
/* MAIN CONTENT END*/

`, "",{"version":3,"sources":["webpack://./src/pages/BewertungAllgemeineInformati.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,uBAAuB;;AAEvB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;;EAEvC,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,sBAAsB;EAC3C,uBAAuB,EAAE,wBAAwB;EACjD,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,6BAA6B;EAC7B,WAAW;EACX,kBAAkB,EAAE,0CAA0C;AAChE;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,sBAAsB;EAC3C,uBAAuB,EAAE,wBAAwB;EACjD,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,WAAW;EACX,kBAAkB,EAAE,0CAA0C;AAChE;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gCAAgC;EAChC,YAAY;AACd;AACA,sBAAsB;;AAEtB,sBAAsB;AACtB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,kCAAkC;EAClC,oBAAoB;EACpB,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;;EAE7B,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;EACxC,eAAe;;EAEf,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA;EACE,mCAAmC,EAAE,iCAAiC;EACtE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;EACX,gCAAgC;EAChC,aAAa;EACb,kBAAkB;;EAElB,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,UAAU;AACZ;AACA;;;EAGE,YAAY;EACZ,kBAAkB;;EAElB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;;EAEf,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;EACE;IACE,iCAAiC;IACjC,UAAU;EACZ;EACA;IACE,6CAA6C;IAC7C,UAAU;EACZ;AACF;;;EAGE,sBAAsB;EACtB,+BAA+B;AACjC;AACA,oBAAoB","sourcesContent":[".bewertung-allgemeine-screen{\r\n  position: relative;\r\n  /*TEXT FONT*/\r\n  font-family: Inter;\r\n  font-style: normal;\r\n}\r\n\r\n/* SIDE SELECTOR START*/\r\n\r\n.selector-container{\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: row;\r\n  top: 35px;\r\n  height: fit-content;\r\n  margin-right: 42px;\r\n  margin-left: 42px;\r\n  border-radius: 10px;\r\n  background: var(--searchbar-background);\r\n\r\n  /*Text Font*/\r\n  text-align: center;\r\n  /* Inter / 24 sp • H5 */\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n  line-height: 36px;\r\n}\r\n\r\n.selector-item-selected {\r\n  display: flex;\r\n  align-items: center; /* Center vertically */\r\n  justify-content: center; /* Center horizontally */\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  margin: 5px;\r\n  background: var(--white-base);\r\n  width: 100%;\r\n  text-align: center; /* Center text within the flex container */\r\n}\r\n\r\n.selector-item-not-selected {\r\n  display: flex;\r\n  align-items: center; /* Center vertically */\r\n  justify-content: center; /* Center horizontally */\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  margin: 5px;\r\n  width: 100%;\r\n  text-align: center; /* Center text within the flex container */\r\n}\r\n\r\n.selector-divider {\r\n  width: 1.48px;\r\n  height: 50.8px;\r\n  background-color: var(--gray-20);\r\n  margin: 10px;\r\n}\r\n/* SIDE SELECTOR END */\r\n\r\n/* MAIN CONTENT START*/\r\n.singleContent-container1 {\r\n  position: relative;\r\n  margin-top: 80px;\r\n  margin-left: var(--content-space);\r\n  margin-right: var(--content-space);\r\n  margin-bottom: 118px;\r\n  /* Add vertical gap between children */\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 20px;\r\n  gap: 30px;\r\n  border-radius: 10px;\r\n  border: 1px solid var(--border);\r\n  background: var(--white-base);\r\n\r\n  /* TEXT FONT */\r\n  font-family: Poppins;\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 150%; /* 18px */\r\n}\r\n\r\n.singleContent-container1-selector{\r\n  position: relative;\r\n  margin-right: 0;\r\n  margin-left: auto;\r\n  padding: 5px 10px;\r\n  width: fit-content;\r\n  background-color: var(--gray-20);\r\n  border-radius: 8px;\r\n  border: none;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n  cursor: pointer;\r\n\r\n  /* TEXT FONT */\r\n  font-family: Poppins;\r\n  font-size: 20px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 150%; /* 18px */\r\n}\r\n\r\n.ba-singleContent-container-selector-item {\r\n  background-color: var(--white-base); /* Background color for options */\r\n  color: var(--gray-40);\r\n}\r\n\r\n.HeaderCell-Custom {\r\n  font-family: Poppins;\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  line-height: 150%;\r\n}\r\n\r\n.table-content-editing-input {\r\n  width: 90%;\r\n  height: 15px;\r\n  margin: 3px;\r\n  border: 1px solid var(--gray-20);\r\n  outline: none;\r\n  border-radius: 5px;\r\n\r\n  padding:2%;\r\n  font-family: Poppins;\r\n}\r\n.table-content-editing-input-red{\r\n  border: 1px solid var(--accents-alizarin-red);\r\n}\r\n.table-content-edit-span {\r\n  padding:3%;\r\n}\r\n.table-content-save-button,\r\n.table-content-stop-button,\r\n.table-content-edit-button{\r\n  height: 30px;\r\n  border-radius: 5px;\r\n\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  cursor: pointer;\r\n\r\n  color: white;\r\n  font-family: Poppins;\r\n  font-weight: 600;\r\n}\r\n\r\n.table-content-edit-button{\r\n  border: none;\r\n  background-color: var(--blue-50);\r\n}\r\n.table-content-save-stop-button{\r\n  display: flex;\r\n  flex-direction: row;\r\n  gap: 10%;\r\n}\r\n  .table-content-save-button{\r\n    background-color: var(--green-50);\r\n    width: 45%;\r\n  }\r\n  .table-content-stop-button{\r\n    background-color: var(--accents-alizarin-red);\r\n    width: 45%;\r\n  }\r\n.table-content-save-button:hover,\r\n.table-content-stop-button:hover,\r\n.table-content-edit-button:hover {\r\n  transform: scale(1.07); \r\n  transition: transform 0.3s ease;\r\n}\r\n/* MAIN CONTENT END*/\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
